import { X } from "lucide-react";
import type { FiltrosNaUrl } from "./useFiltrosNaUrl";

/*
 * Os filtros aplicados, como chips removíveis acima da tabela (doc 06a §4.2).
 *
 * Filtro sem chip é filtro invisível: a lista parece completa, e o operador procura o
 * que o filtro esconde. Filtro fixo da tela, como o cedente na aba Boletos, não passa
 * por aqui, porque não é para remover.
 */
export function ChipsDeFiltro<C extends string>({
  filtros,
}: {
  filtros: Pick<FiltrosNaUrl<C>, "aplicados" | "ajustar" | "limpar">;
}) {
  if (filtros.aplicados.length === 0) return null;

  return (
    <div className="flex flex-wrap items-center gap-2">
      {filtros.aplicados.map(({ chave, rotulo, texto }) => (
        <button
          key={chave}
          type="button"
          aria-label={`Remover filtro ${rotulo}: ${texto}`}
          onClick={() => filtros.ajustar(chave, "")}
          className="inline-flex items-center gap-1 rounded-full border border-fio-forte bg-superficie-2 py-[2px] pl-2 pr-1 text-[12px] text-texto-2 hover:text-texto"
        >
          <span className="rotulo">{rotulo}</span>
          <span className="text-texto">{texto}</span>
          <X aria-hidden="true" className="size-3.5" />
        </button>
      ))}

      <button
        type="button"
        onClick={filtros.limpar}
        className="text-[12px] text-texto-2 underline-offset-2 hover:text-texto hover:underline"
      >
        Limpar filtros
      </button>
    </div>
  );
}
